<template>
    <div class="min-h-screen flex flex-col">
        <LayoutsDefaultPageHeader />
        
        <!-- Main content area - grows to fill space -->
        <main class="flex-grow">
            <slot />
        </main>
        
        <!-- Footer stays at bottom -->
        <LayoutsDefaultPageFooter />
    </div>
</template>

<style scoped>
/* Ensure proper layout structure */
</style>